import { Component, input } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

import { TranslateTokenPipe } from "../../../../core/pipes";
import { GovDirection } from "../../../models";

@Component({
  selector: "adaa-directions-card-grid",
  imports: [TranslatePipe, TranslateTokenPipe],
  templateUrl: "./directions-card-grid.html",
  styleUrl: "./directions-card-grid.scss",
})
export class DirectionsCardGridComponent {
  governmentDirectionsTitle = input.required<string>();
  governmentSubDirectionsTitle = input.required<string>();
  govDirectionsList = input.required<GovDirection[]>();
  mainSubGovDirection = input<number | undefined>(undefined);
}
